import defaultFormInput from '#themes/default/default/components/formInput/formInput.js';

import cFormLine from '#themes/default/web/components/formLine/formLine.js';
import cInput from '#themes/default/web/components/input/input.js';

export default {
	components: {
		cFormLine,
		cInput
	},
	extends: defaultFormInput
};
